import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import './styles.css';
import CustomTable from '../../../components/CustomTable';

import { APROBADO, REGISTRADO, ANULADO, RECHAZADO, IMPORTADO } from '../../../common/types/ordenCompraEstadoType';

export default function DetalleIngreso(props) {
    const renderColor = (row) => {
        if (row.idOrdenCompraEstado === REGISTRADO)
            return 'blue';
        if (row.idOrdenCompraEstado === APROBADO)
            return 'green';
        if (row.idOrdenCompraEstado === RECHAZADO)
            return 'orange';
        if (row.idOrdenCompraEstado === IMPORTADO)
            return 'gold';
        if (row.idOrdenCompraEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[

                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoProveedor',
                    key: 'tipoDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },

                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },

                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },

                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Codigo Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Marca',
                    dataIndex: 'marca',
                    key: 'marca',
                    sorter: true
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },

                {
                    title: 'Valor Unitario',
                    dataIndex: 'valorUnitario',
                    key: 'valorUnitario',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Precio Unitario',
                    dataIndex: 'precioUnitario',
                    key: 'precioUnitario',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Igv',
                    dataIndex: 'igv',
                    key: 'igv',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },

                {
                    title: 'Estado',
                    dataIndex: 'nombreOrdenCompraEstado',
                    key: 'nombreOrdenCompraEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
